import { isValidPhoneNumber } from "react-phone-number-input";
import {
  object, ref, string, ValidationError,
} from "yup";

import { TUserRole } from "@/features/Auth";

export const updateUserValidation = object().shape({
  name: string().matches(/^\S+$/, "whiteSpace").required(),
  surname: string().matches(/^\S+$/, "whiteSpace").required(),
  phone: string()
    .test("phone-validation", (value, context) => {
      if (!value) {
        return true;
      }
      return isValidPhoneNumber(value) || new ValidationError("phone", value, context.path);
    }),
  email: string().trim().email()
    .required(),
  password: string()
    .min(6, "passwordMinRule")
    .max(64, "passwordMaxRule").optional(),
  confirmPassword: string()
    .optional()
    .oneOf([ref("password")], "passwordsMustMatch"),
  role: string<TUserRole>().required(),
});
